<template>
  <div class="company-activity" :class="{english:lang=='EN'}" :style="isMobile?{paddingTop:'0'}:''">
    <div class="wow fadeInUp hidden-xs"
         style="display: flex;align-items: center;flex-direction: column;margin-bottom: 1.75rem;">
      <div class="title">{{$t('joinUs.companyNewsTitle')}}</div>
    </div>
    <Lantern  :detailContent="companyNews"></Lantern>
  </div>
</template>

<script>
  import Lantern from '@/components/common/Lantern'
  import {mapGetters} from 'vuex'

  export default {
    name: 'CompanyNews',
    components: {
      Lantern
    },
    props: {},
    data () {
      return {
        companyNews:{
          id: 'companyNews',
          title: 'joinUs.companyNews',
          introduction: 'joinUs.companyNewsTip',
          model: 'card',
          bkColor: 'black',
           events: [
            // {
            //   img: require('../../../assets/img/joinus/companyNews1.png'),
            //   // time: '2021.10',
            //   event: 'joinUs.message2.message01'
            // },
            {
              img: require('../../../assets/img/joinus/companyNews2.png'),
              // time: '2021.11',
              event: 'joinUs.message2.message03'
            },
            {
              img: require('../../../assets/img/joinus/companyNews3.png'),
              // time: '2022.05',
              event: 'joinUs.message2.message02'
            },
            {
              img: require('../../../assets/img/joinus/companyNews5.png'),
              // time: '2022.08',
              event: 'joinUs.message2.message04'
            }

          ]
        }
      }
    },
    methods: {},
    mounted () {
    },
    computed: {
      ...mapGetters(['isMobile', 'lang']),
      getComponentName () {
        return 'CompanyNews'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .company-activity {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 8rem;

    .title {
      font-size: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      line-height: 4.38rem;
      letter-spacing: 0.25rem;
    }

    .underline {
      max-width: 9.75rem;
      margin-top: 1.5rem;
    }
  }

  .english {
    .title {
      letter-spacing: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/joinus/ComPanyNews.vue